export const ORIGINAL_LANGUAGE = 'original';
export const ORIGINAL_ICON = '🌐';

const FLAGS: Record<string, string> = {
  ar: '🇦🇪',
  zh: '🇨🇳',
  en: '🇺🇸',
  fr: '🇫🇷',
  hi: '🇮🇳',
  ja: '🇯🇵',
  ru: '🇷🇺',
  es: '🇪🇸',
};

export const languageLabel = (code: string): string => {
  try {
    return new Intl.DisplayNames(['en'], { type: 'language' }).of(code) || code.toUpperCase();
  } catch {
    return code.toUpperCase();
  }
};

export const languageIcon = (code: string): string => FLAGS[code] || code.toUpperCase();

export const browserLanguage = (): string | undefined => {
  const base = navigator.language?.split('-')[0]?.toLowerCase();
  return base || undefined;
};
